import { parseApiUtcToLocalDate } from './apiDateTime';

/**
 * Versiyon seçici etiketleri: "v1", "V 2" → "Version 1", "Version 2".
 * Sadece `v` ile başlayan isimler dönüşür; diğerleri aynen gösterilir.
 * API/hash `name` değeri değişmez; yalnızca `label` için kullanılır.
 */
export function formatVersionSelectorLabel(raw: string | undefined | null): string {
  if (raw == null) return '';
  const trimmed = String(raw).trim();
  if (!trimmed) return '';

  const m = trimmed.match(/^v\s*(.*)$/i);
  if (!m) return trimmed;

  const body = m[1].trim();
  if (!body) return trimmed;

  if (/^[\d.]+$/.test(body)) {
    return `Version ${body}`;
  }

  return `Version ${body}`;
}

/** Versiyon satırında isim yanında gösterilecek tarih (createdAt, yoksa updatedAt). */
export function formatVersionOptionDate(version: {
  createdAt?: string | Date | null;
  updatedAt?: string | Date | null;
} | null | undefined): string {
  if (version == null) return '';
  const raw = version.createdAt ?? version.updatedAt;
  if (raw == null || raw === '') return '';
  const date = parseApiUtcToLocalDate(raw);
  if (!date) return '';
  try {
    return date.toLocaleDateString('tr-TR', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    });
  } catch {
    return date.toISOString().slice(0, 10);
  }
}
